import { AxiosResponse } from "axios";
import { IProcurementReportApi, api } from "../base";
import {
	ExportorderscreenreportRequest,
	ExportSupplierPerformanceRequest,
	ProcurementReportRequest,
	SearchGridShippingAndBillingRequest,
	SearchGridSupplierPerformanceRequest,
} from "@/main/models/request";
import {
	DynamicReportResponse,
	ProcurementReportResponse,
	SearchGridRequoteTraceabilityResponse,
	SearchGridShippingCostResponse,
	SupplierPerformanceReportResponse,
} from "@/main/models/response";
import { PaginationResponse } from "@/main/models/common/paginationResponse";
import { Result } from "@/main/models/common/resultResponse";
import { TimeoutRequestConfigurationEnum } from "@/main/services/enum/TimeoutRequestConfigurationEnum";
import { SearchGridRequoteTraceabilityRequest, ExportRequoteTraceabilityRequest } from "@/main/models/request";
import {
	DynamicReportQueryRequest,
	DynamicReportRequest,
	DynamicReportUserGroupRequest,
} from "@/main/models/request/dynamicReportRequest";
import {
	DynamicReportGridRequest,
	DynamicReportHistoryGridRequest,
} from "@/main/models/request/dynamicReportGridRequest";
import {
	DynamicReport_VariableResponse,
	DynamicReportGridResponse,
	DynamicReportHistoricalDetailsResponse,
	DynamicReportHistoricalResponse,
	DynamicReportUserGroupResponse,
} from "@/main/models/response/dynamicReportResponse";
import qs from "qs";

const baseRoute: string = "ProcurementReport";

export class ProcurementReportApi extends IProcurementReportApi {
	exportDynamicReport(request: DynamicReportQueryRequest, timeout: number): Promise<AxiosResponse<Result<boolean>>> {
		return api.post(`${baseRoute}/exportDynamicReport`, request, {
			timeout,
		});
	}
	getDynamicReportFilters(guidDynamicReport: string): Promise<AxiosResponse<Result<DynamicReport_VariableResponse[]>>> {
		return api.get(`${baseRoute}/getdynamicreportfilters`, {
			params: { guidDynamicReport },
		});
	}
	searchgrid(request: ProcurementReportRequest): Promise<AxiosResponse<PaginationResponse<ProcurementReportResponse>>> {
		return api.get(`${baseRoute}/searchgrid`, {
			params: request,
			timeout: TimeoutRequestConfigurationEnum.TenMinutesInMilliseconds,
		});
	}

	exportOrder(request: ProcurementReportRequest): Promise<AxiosResponse<Result<string>>> {
		return api.get(`${baseRoute}/exportOrder`, {
			timeout: TimeoutRequestConfigurationEnum.TwoMinutesInMilliseconds,
			params: request,
		});
	}

	searchGridBilling(
		request: ProcurementReportRequest,
	): Promise<AxiosResponse<PaginationResponse<ProcurementReportResponse>>> {
		return api.get(`${baseRoute}/searchGridBilling`, { params: request });
	}

	exportBilling(request: ProcurementReportRequest): Promise<AxiosResponse<Result<string>>> {
		return api.get(`${baseRoute}/exportBilling`, { params: request });
	}

	searchGridShippingCost(
		request: SearchGridShippingAndBillingRequest,
	): Promise<AxiosResponse<PaginationResponse<SearchGridShippingCostResponse>>> {
		return api.get(`${baseRoute}/searchGridShippingCost`, { params: request });
	}

	shippingCostReportExport(request: ProcurementReportRequest): Promise<AxiosResponse<Result<string>>> {
		return api.get(`${baseRoute}/shippingCostReportExport`, {
			params: request,
		});
	}
	searchGridSupplierPerformance(
		request: SearchGridSupplierPerformanceRequest,
	): Promise<AxiosResponse<PaginationResponse<SupplierPerformanceReportResponse>>> {
		return api.get(`${baseRoute}/searchGridSupplierPerformance`, {
			params: request,
			paramsSerializer: (params) => {
				return qs.stringify(params, { arrayFormat: "repeat" });
			},
		});
	}
	exportSupplierPerformance(request: ExportSupplierPerformanceRequest): Promise<AxiosResponse<Result<string>, any>> {
		return api.get(`${baseRoute}/exportSupplierPerformance`, {
			params: request,
			paramsSerializer: (params) => {
				return qs.stringify(params, { arrayFormat: "repeat" });
			},
		});
	}
	searchGridRequoteTraceability(
		request: SearchGridRequoteTraceabilityRequest,
	): Promise<AxiosResponse<PaginationResponse<SearchGridRequoteTraceabilityResponse>>> {
		return api.get(`${baseRoute}/searchGridRequoteTraceability`, {
			params: request,
			timeout: TimeoutRequestConfigurationEnum.FiveMinutesInMilliseconds,
		});
	}

	exportRequoteTraceability(request: ExportRequoteTraceabilityRequest): Promise<AxiosResponse<Result<string>>> {
		return api.get(`${baseRoute}/exportRequoteTraceability`, {
			params: request,
			timeout: TimeoutRequestConfigurationEnum.FiveMinutesInMilliseconds,
		});
	}

	exportOrderScreenReport(request: ExportorderscreenreportRequest): Promise<AxiosResponse<Result<string>>> {
		return api.get(`${baseRoute}/exportorderscreenreport`, { params: request });
	}

	saveDynamicReport(request: DynamicReportRequest): Promise<AxiosResponse<Result<string>>> {
		return api.post(`${baseRoute}/savedynamicreport`, request);
	}

	getDynamicReportDetails(guidDynamicReport: string): Promise<AxiosResponse<Result<DynamicReportResponse>>> {
		return api.get(`${baseRoute}/getdynamicreportdetails`, {
			params: { GuidDynamicReport: guidDynamicReport },
		});
	}

	getDynamicReportUserGroups(
		request: DynamicReportUserGroupRequest,
	): Promise<AxiosResponse<Result<DynamicReportUserGroupResponse[]>>> {
		return api.get(`${baseRoute}/getdynamicreportusergroups`, { params: request });
	}

	GetDynamicReportHistoryGrid(
		request: DynamicReportHistoryGridRequest,
	): Promise<AxiosResponse<PaginationResponse<DynamicReportHistoricalResponse>>> {
		return api.get(`${baseRoute}/getdynamicreporthistorygrid`, {
			params: request,
		});
	}

	getDynamicReportHistDetails(
		guidDynamicReportHistorical: string,
	): Promise<AxiosResponse<Result<DynamicReportHistoricalDetailsResponse[]>>> {
		return api.get(`${baseRoute}/getdynamicreporthistdetails`, {
			params: { GuidDynamicReportHistorical: guidDynamicReportHistorical },
		});
	}

	dynamicReportSearchGrid(
		request: DynamicReportGridRequest,
	): Promise<AxiosResponse<PaginationResponse<DynamicReportGridResponse[]>>> {
		return api.get(`${baseRoute}/getdynamicreportgrid`, { params: request });
	}
}
